export default __webpack_public_path__ + "static/media/swf.06fd49d3.svg";